import React from 'react';
import "../auth/styles.css";
import TermsAndConditions from '../auth/TermsAndConditions';
import logo from '../../images/logo.png';

const Privacy = () => {
  return (
    <div className="privacy-page flex min-h-screen justify-center">
      <div className="privacy-wrapper flex flex-[1200px_0_0] flex-col items-center justify-center p-10 [&_.tandc-container_p]:mt-0 [&_.tandc-container_p]:mb-4 [&_.tandc-container_p]:w-full [&_.tandc-container_p]:text-[16px] [&_.tandc-container_p]:font-light [&_.tandc-container_p]:leading-[27px]">
        <img src={logo} alt="Logo" className="logo w-[240px] mb-[130px]" />
        <h1 className="mt-5 mb-5 w-full text-[60px] font-medium tracking-[-4px]">
          Terms &amp; Conditions
        </h1>
        <TermsAndConditions />
      </div>
    </div>
  );
}

export default Privacy;
